import React from "react";
import { Modal } from "react-bootstrap";
import tableStructure from "./tableStructure";
import { BACKGROUND_COLORS } from "./stylemap";

const paddingValues = [1, 2, 3, 4, 5];
const alignValues = {
  top: "Сверху",
  middle: "Центр",
  bottom: "Внизу",
};

export default class EditorTableDialog extends React.Component {
  constructor(props) {
    super(props);

    let table =
      this.props.currentTable && Array.isArray(this.props.currentTable)
        ? this.props.currentTable
        : false;

    let { row, col } = tableStructure.cellLocate(table, this.props.block.key);
    let cell = table[row][col];

    let data = {};
    let cellPropKeys = Object.keys(tableStructure.cellDefaults());
    cellPropKeys.forEach((prop) => {
      data[prop] = cell[prop];
    });

    this.state = {
      table,
      data,
      row,
      col,
      cell,
    };
  }
  onHide = () => {
    this.props.onHide();
  };
  onSave = () => {
    this.props.onSave(this.state);
  };
  onChange = (e) => {
    let id = e.target.id;
    let type = e.target.getAttribute("type");
    let value = type === "checkbox" ? e.target.checked : e.target.value;

    let data = this.state.data;

    data[id] = value;
    this.setState({ data });
  };

  onChangeColor = (color) => {
    let data = this.state.data;

    data["backgroundColor"] = color;
    this.setState({ data });
  };

  borderSetAll = () => {
    let data = this.state.data;
    data.borderLeft = true;
    data.borderRight = true;
    data.borderTop = true;
    data.borderBottom = true;
    this.setState({ data });
  };

  borderSetNone = () => {
    let data = this.state.data;
    data.borderLeft = false;
    data.borderRight = false;
    data.borderTop = false;
    data.borderBottom = false;
    this.setState({ data });
  };

  render() {
    return (
      <>
        <Modal show onHide={this.onHide}>
          <Modal.Header closeButton>
            <Modal.Title>Ячейка таблицы</Modal.Title>
          </Modal.Header>

          {this.state.table && (
            <Modal.Body>
              <div className="row">
                <div className="col-lg-6">
                  <h5 className="mb-5">Отступ, положение</h5>
                  <div className="form-group pt-3">
                    <div className="form-group">
                      <label>Отступ внутри:</label>
                      <select
                        value={this.state.data.padding || ""}
                        id="padding"
                        onChange={this.onChange}
                        className="form-control"
                      >
                        <option value=""></option>
                        {paddingValues.map((padding) => (
                          <option
                            key={padding}
                            value={padding}
                          >{`${padding} пт.`}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Положение по вертикали:</label>
                      <select
                        value={this.state.data.verticalAlign || ""}
                        id="verticalAlign"
                        onChange={this.onChange}
                        className="form-control"
                      >
                        <option value=""></option>
                        {Object.keys(alignValues).map((verticalAlign) => (
                          <option key={verticalAlign} value={verticalAlign}>
                            {alignValues[verticalAlign]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3">
                  <h5 className="mb-5">Заливка</h5>
                  <div className="form-group pt-3">
                    {BACKGROUND_COLORS.map((color) => (
                      <button
                        key={color}
                        onClick={() => this.onChangeColor(color)}
                        className={`btn ml-1 mt-1 btn-icon ${
                          this.state.data.backgroundColor === color
                            ? "btn-secondary"
                            : "btn-light"
                        }`}
                      >
                        <div
                          className="color-box"
                          style={{ background: color }}
                        ></div>
                      </button>
                    ))}
                  </div>
                </div>
                <div className="col-lg-3">
                  <h5 className="mb-5">Границы</h5>
                  <div className="form-group pt-3">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderLeft"
                        onChange={this.onChange}
                        checked={this.state.data.borderLeft}
                      />
                      <span className="mr-2"></span>
                      Слева
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderRight"
                        onChange={this.onChange}
                        checked={this.state.data.borderRight}
                      />
                      <span className="mr-2"></span>
                      Справа
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderTop"
                        onChange={this.onChange}
                        checked={this.state.data.borderTop}
                      />
                      <span className="mr-2"></span>
                      Сверху
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderBottom"
                        onChange={this.onChange}
                        checked={this.state.data.borderBottom}
                      />
                      <span className="mr-2"></span>
                      Снизу
                    </label>
                  </div>
                  <div className="form-group">
                    <button
                      onClick={this.borderSetAll}
                      className="btn btn-light w-100 mb-2"
                    >
                      Все
                    </button>
                    <button
                      onClick={this.borderSetNone}
                      className="btn btn-light w-100"
                    >
                      Ни одной
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          )}

          <Modal.Footer>
            <button onClick={this.onSave} className="btn btn-primary">
              Сохранить
            </button>
            <button onClick={this.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
